import { useMutation } from '@tanstack/react-query';
import { httpDeleteTemplate } from 'services/backofficeIntegration/http/endpoints/textGeneration/commandTemplates/httpDeleteTemplate';

export const useDeleteTemplateMutation = () =>
  useMutation({
    mutationFn: httpDeleteTemplate.callEndpoint
  });
